export interface PlanMapping {
  planKey: "trialing" | "essentials" | "growth" | "enterprise";
  billingCycle: "monthly" | "yearly";
}

export const PLAN_MAPPING_DEV: Record<string, PlanMapping> = {
  price_1SqLKlJalV1b7fj40SABWlwd: { planKey: "essentials", billingCycle: "monthly" },
  price_1SqLRtJalV1b7fj4y4bP9ec6: { planKey: "essentials", billingCycle: "yearly" },
  price_1SqLSYJalV1b7fj4jq2eYFOd: { planKey: "growth", billingCycle: "monthly" },
  price_1SqLTwJalV1b7fj4ZuZKdbGy: { planKey: "growth", billingCycle: "yearly" },
  // 2025 Pricing
  price_1RDpkuJalV1b7fj45sa6sW0A: { planKey: "essentials", billingCycle: "monthly" },
  price_1RDplAJalV1b7fj44onPM31C: { planKey: "essentials", billingCycle: "yearly" },
  price_1RDpjGJalV1b7fj4Uc3s4bVH: { planKey: "growth", billingCycle: "monthly" },
  price_1RDpkbJalV1b7fj4rENP13Bp: { planKey: "growth", billingCycle: "yearly" },
};

export const PLAN_MAPPING_PROD: Record<string, PlanMapping> = {
  // 2026 Pricing
  price_1Sr6s0JalV1b7fj4ISsf0pkh: {
    planKey: "essentials",
    billingCycle: "monthly",
  },
  price_1Sr6t3JalV1b7fj4pUCB9GQC: {
    planKey: "essentials",
    billingCycle: "yearly",
  },
  price_1Sr6m1JalV1b7fj4U6GC5D8H: {
    planKey: "growth",
    billingCycle: "monthly",
  },
  price_1Sr6nYJalV1b7fj4RsdqJHlo: { planKey: "growth", billingCycle: "yearly" },
  // 2025 Pricing
  price_1R6DqCJalV1b7fj4mTZJOEeb: {
    planKey: "essentials",
    billingCycle: "monthly",
  },
  price_1RBc06JalV1b7fj4EaMAcJpl: {
    planKey: "essentials",
    billingCycle: "yearly",
  },
  price_1RBNBqJalV1b7fj4aCjqGLn3: {
    planKey: "growth",
    billingCycle: "monthly",
  },
  price_1RBNCYJalV1b7fj40fKvnNDY: { planKey: "growth", billingCycle: "yearly" },
};

export const PLAN_MAPPING =
  process.env.NEXT_PUBLIC_SITE_URL === "https://app.usehindsight.com"
    ? PLAN_MAPPING_PROD
    : PLAN_MAPPING_DEV;
